"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const clinical_trials_entry_1 = __importDefault(require("./clinical-trials-entry"));
const messages_1 = __importDefault(require("../../lib/messages"));
const ClinicalTrials = ({ clinicalTrials }) => {
    // do not render if data not present
    if (!clinicalTrials || clinicalTrials.length === 0) {
        return null;
    }
    return (react_1.default.createElement(styles_1.ExpertiseSectionContainer, null,
        react_1.default.createElement(styles_1.ExpertiseSectionTitle, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.clinicalTrialsSectionTitle))),
        clinicalTrials.map((c, index) => {
            return (react_1.default.createElement(clinical_trials_entry_1.default, { key: `${c.official_title}_${index}`, clinicalTrial: c }));
        })));
};
exports.default = ClinicalTrials;
//# sourceMappingURL=clinical-trials.js.map